import React, { useState, useEffect } from "react";
import "./DatePicker.scss";

function DatePicker({
  invalid,
  label,
  value,
  onChange,
  errorMessage = "Please select a valid date",
  placeholder = "Select date",
}) {
  const [selected, setSelected] = useState(!!value);

  // Update selected state when value changes externally
  useEffect(() => {
    setSelected(!!value);
  }, [value]);

  const handleChange = (e) => {
    onChange(e.target.value);
    setSelected(true);
  };

  return (
    <div className="form-field">
      {label && <div className="dropdown-label">{label}</div>}
      <div className={`datepicker ${invalid ? "datepicker-invalid" : ""}`}>
        <input
          className={selected ? "datepicker-selected" : "datepicker-unselected"}
          type="date"
          value={value || ""}
          onChange={handleChange}
          // placeholder={placeholder}
        />
      </div>
      {invalid && <div className="form-error-message">{errorMessage}</div>}
    </div>
  );
}

export default DatePicker;

// // DatePicker.js
// import React, { useState } from "react";
// import "./DatePicker.scss";

// function DatePicker({ invalid, label, value, onChange }) {
//   const [selected, setselected] = useState(false);
//   return (
//     <>
//       <div className="dropdown-label">{label}</div>
//       <div className={invalid ? "datepicker-invalid datepicker" : "datepicker"}>
//         {selected ? (
//           <input
//             className="datepicker-selected"
//             type="date"
//             value={value}
//             onChange={(e) => onChange(e.target.value)}
//           />
//         ) : (
//           <input
//             className="datepicker-unselected"
//             type="date"
//             value={value}
//             onChange={(e) => {
//               onChange(e.target.value);
//               setselected(true);
//             }}
//           />
//         )}
//       </div>
//     </>
//   );
// }

// export default DatePicker;
